module.exports = __webpack_public_path__ + "img/叹气.40338709.png";